import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

interface SidebarInfoLinkProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  to?: string;
  href?: string;
  target?: string;
  rel?: string;
  onClick?: () => void;
}

const iconBadgeSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 36,
  height: 36,
  borderRadius: 2,
  bgcolor: '#EEF2FF',
  color: '#6366F1',
  flexShrink: 0,
};

const SidebarInfoLink: React.FC<SidebarInfoLinkProps> = ({
  icon,
  title,
  subtitle,
  to,
  href,
  target,
  rel,
  onClick,
}) => {
  const content = (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Box>
        <Typography sx={{ m: 0, fontWeight: 700, color: '#0F172A' }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ m: 0, color: '#64748B' }}>
          {subtitle}
        </Typography>
      </Box>
      <Box sx={iconBadgeSx}>{icon}</Box>
    </Stack>
  );

  const linkStyle = { textDecoration: 'none' };

  if (to) {
    return (
      <Link to={to} aria-label={title} onClick={onClick} style={linkStyle}>
        {content}
      </Link>
    );
  }

  return (
    <a
      href={href}
      target={target}
      rel={rel}
      aria-label={title}
      onClick={onClick}
      style={linkStyle}
    >
      {content}
    </a>
  );
};

export default SidebarInfoLink;
